//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { mapMutations } from 'vuex'
export default {
  name: 'InternationalClassificationofHeadacheDisorders',
  created () {
    this.hideLoad()
  },
  methods: {
    ...mapMutations(['hideLoad'])
  }
}



// WEBPACK FOOTER //
// ./src/pages/formulas/Neuro/InternationalClassificationofHeadacheDisorders.vue